import List from 'layouts/refunds/List.js';
import Details from 'layouts/refunds/Details.js';
import ProtectedRoute from "routes/protectedRoutes.js";

const RefundRoutes = [
    {
      route: "/refunds/list/:pageNo",
      key: "manage-refunds",
      component: <ProtectedRoute check="logout"><List /></ProtectedRoute>
    },
    {
      route: "/refunds/details/:refundID",
      key: "refund-details",
      component: <ProtectedRoute check="logout"><Details /></ProtectedRoute>
    },    
  ];

export default RefundRoutes;
 